import { render, staticRenderFns } from "./PhoFileDragAndDrop.vue?vue&type=template&id=9acdbe34&lang=pug"
import script from "./PhoFileDragAndDrop.vue?vue&type=script&lang=js"
export * from "./PhoFileDragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./PhoFileDragAndDrop.vue?vue&type=style&index=0&id=9acdbe34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports